export interface SecurityRestrict {
    code?: string;
    desc?: string;
}
export const AllSecurityRecords: SecurityRestrict = {
    code: 'ALL',
    desc: 'All'
};

